import React from 'react'
import { StyleSheet } from 'react-native'

import {
  B2,
  B5,
  BottomSheet,
  Button,
  colors,
  H3,
  SH2,
  Stack,
  XStack,
} from '@zet/design-system'
import { i18n } from '@zet/localization'
import { CustomBottomSheetProps } from '@zet/zet-prime'
import { Image } from 'expo-image'
import { LinearGradient } from 'expo-linear-gradient'

export default function CustomBottomSheet({
  isVisible,
  onClose,
  iconImage,
  headerText,
  subHeaderText,
  earningsWithZetPrime,
  buttons,
  footerText,
  headerSecondaryText,
  showBillingInfo,
  amount,
}: CustomBottomSheetProps) {
  return (
    <BottomSheet
      visible={isVisible}
      disableBottomSheet={onClose}
      sheetName="custom_bottom_sheet"
    >
      <Stack className="pt-4">
        {iconImage && (
          <Image style={styles.icon} source={iconImage} contentFit="contain" />
        )}

        {earningsWithZetPrime && (
          <LinearGradient
            colors={['#4CAF50', '#204921']}
            start={{ x: 1, y: 0 }}
            end={{ x: 0, y: 0 }}
            style={styles.gradient}
          >
            <SH2 className="text-white">
              {i18n.t('zetPrime.youveEarned', {
                amount: earningsWithZetPrime,
              })}
            </SH2>
          </LinearGradient>
        )}
        <Stack className="my-4 px-4">
          <H3 className="text-center text-grays-80 font-bold ">{headerText}</H3>
          {headerSecondaryText && (
            <H3 className="text-center text-primary-100 font-bold ">
              {headerSecondaryText}
            </H3>
          )}
        </Stack>

        {subHeaderText && (
          <B2 className="text-centertext-grays-70 font-normal px-4 mb-4 text-center">
            {subHeaderText}
          </B2>
        )}

        <B2 className="text-grays-80 mb-2 text-left self-start px-4">
          {footerText}
        </B2>

        <Stack className="w-full py-[12] px-4" style={styles.buttonContainer}>
          {buttons.map((button, index) => (
            <Button
              key={index}
              className={`w-full mb-2 ${button?.className ?? ''}`}
              size="lg"
              loading={button?.loading ?? false}
              variant={button?.variant ?? 'primary'}
              textOnly={button?.textOnly ?? false}
              onPress={button?.onPress}
              textStyle={button?.textStyle ?? ''}
            >
              {button.text}
            </Button>
          ))}
        </Stack>

        {showBillingInfo && amount && (
          <XStack className="justify-center px-4 pb-4">
            <B5 className={`text-black font-normal`}>
              {i18n.t('zetPrime.billedMonthly', {
                amount: amount,
              })}{' '}
            </B5>
            <B5>{i18n.t('zetPrime.cancelAnytime')}</B5>
          </XStack>
        )}
      </Stack>
    </BottomSheet>
  )
}

const styles = StyleSheet.create({
  icon: {
    width: 100,
    height: 100,
    alignSelf: 'center',
  },
  gradient: {
    borderRadius: 100,
    paddingHorizontal: 12,
    paddingVertical: 6,
    marginTop: 16,
  },
  buttonContainer: {
    borderTopWidth: 1,
    borderTopColor: colors.primary[20],
  },
})
